export const inputClassName =
  'w-full rounded-lg border border-input bg-background px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground focus:border-ring focus:outline-none focus:ring-1 focus:ring-ring';

export const labelClassName = 'mb-1.5 block text-sm font-medium text-foreground';
